var swiper = new Swiper(".new-featured-sliders", {
      slidesPerView: 4,
      spaceBetween: 10,
      loop: false,
      centeredSlides: false,
      navigation: {
        nextEl: ".swiper-button-next121",
        prevEl: ".swiper-button-prev121",
      },
      breakpoints: {
        1500: {
          slidesPerView: 6,
          spaceBetween: 30,
        },
        990: {
          slidesPerView: 6,
          spaceBetween: 50,
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        0: {
          slidesPerView: 3,
          spaceBetween: 10,
        }
      }
    });